<template>
  <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
      <div>
        <div class="w-full surface-card py-4 px-5 sm:px-4">
          <div class="text-center">
            <img class="max-w-25rem" src="/layout/images/login-vector.jpg" alt="login-vector" />
          </div>
          <div class="text-center mb-5">
            <div class="text-900 text-3xl font-medium mb-3">فروشگاه مهر گالری</div>
          </div>
          <div>
            <label for="email1" class="block text-900 text-xl font-medium mb-2">آدرس ایمیل</label>
            <InputText
              id="email1"
              type="text"
              placeholder="آدرس ایمیل خود را وارد کنید"
              class="w-full md:w-30rem mb-5"
              style="padding: 1rem"
              v-model="email"
            />

            <label for="password1" class="block text-900 font-medium text-xl mb-2">رمز عبور</label>
            <Password
              id="password1"
              v-model="password"
              placeholder="رمز عبور خود را وارد کنید"
              :toggleMask="true"
              class="w-full mb-3"
              inputClass="w-full"
              :inputStyle="{ padding: '1rem' }"
            ></Password>
            <router-link :to="{ name: 'ForgotPassword' }"> رمز عبور خود را فراموش کردید؟ </router-link>

            <Button
              :loading="loading"
              label="ورود"
              class="w-full text-xl p-button-sm mt-2"
              @click="handleLogin"
            ></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <AppConfig simple />-->
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { saveCredentials, saveToken } from '@/utils/auth';
import GlobalService from '../service/GlobalService';
import { useRouter } from 'vue-router';
import mitt from 'mitt';
import { useToast } from 'primevue/usetoast';
import { globalAxiosErrorHandler } from '@/utils/globalHelpers';
const toast = useToast();

const GlobalServiceItem = ref(new GlobalService());
const email = ref('');
const password = ref('');
const loading = ref(false);
const router = useRouter();
const emitter = mitt();
const handleLogin = async () => {
  loading.value = true;
  const loginData = {
    email: email.value,
    password: password.value
  };
  await GlobalServiceItem.value
    .login(loginData)
    .then((data) => {
      saveToken(data.data.data.token);
      saveCredentials({
        id: data.data.data.user.id,
        username: data.data.data.user.email,
        name: data.data.data.user.full_name,
        phone: data.data.data.user.phone,
        mobile: data.data.data.user.mobile
      });
      localStorage.setItem('user_permissions', JSON.stringify(data.data.data.permissions));
      emitter.emit('show-alert', {
        message: 'Login successful!',
        type: 'success'
      });
      router.push('/');
    })
    .catch(() => {
      showToast({ type: 'error', message: 'City Created Successfully' });
    })
    .finally(() => {
      loading.value = false;
    });
};
emitter.on('toast', (data) => showToast(data));
emitter.on('toast-axios', (error) => showAxiosToast(error));
const showAxiosToast = (error) => {
  toast.add({
    severity: 'error',
    summary: globalAxiosErrorHandler(error).summary,
    detail: globalAxiosErrorHandler(error).detail,
    life: 5000
  });
};

const showToast = (data) => {
  switch (data.type) {
    case 'info':
      toast.add({
        severity: data.type,
        summary: data.title ? data.title : 'Attention',
        detail: data.message,
        life: 2000
      });
      break;
    case 'success':
      toast.add({
        severity: data.type,
        summary: data.title ? data.title : 'Successful operation',
        detail: data.message,
        life: 5000
      });
      break;
    case 'warn':
      toast.add({
        severity: data.type,
        summary: data.title ? data.title : 'Warning',
        detail: data.message,
        life: 4000
      });
      break;
    case 'error':
      toast.add({
        severity: data.type,
        summary: data.title ? data.title : 'Error',
        detail: data.message,
        life: 6000
      });
      break;
  }
};
</script>

<style scoped>
.pi-eye {
  transform: scale(1.6);
  margin-right: 1rem;
}

.pi-eye-slash {
  transform: scale(1.6);
  margin-right: 1rem;
}
</style>
